/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { FiRefreshCw } from 'react-icons/fi';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { Button } from 'reactstrap';
import { FSBTable } from 'components/common/FSBTable';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import {
  ADMIN_UPDATE_DEMAND_STATUS,
  DELETE_DEMAND,
} from 'pages/MarketListing/MarketListingGraphQL';
import { setBidDetails } from 'actions/bidDetailAction';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import {
  demandsInActiveColumns,
  GradeBadge,
} from 'pages/MarketListing/constant';
import { RECORD_DELETED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import Loader from 'components/common/Loader';
import {
  defaultDeleteFilter,
  showSequenceNumber,
  currencyToLocal,
  NumberWithCommasFormat,
} from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import DownloadCSV from 'components/DownloadCSV';
import {
  DEMANDS_QUERY,
  DEMANDS_SUBSCRIPTION_QUERY,
  EXPORTS_DEMANDS,
} from 'utils/CommonGraphQL';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import FilterResultBar from 'components/FilterResultBar';
import MarketListingMobileView from 'pages/MarketListing/components/MarketListingMobileView';
import ReactivateListingModal from 'pages/MarketListing/components/ReactivateListingModal';

const getValidLinkedDemands = (demand) => {
  if (!demand?.linkedDemands || !Array.isArray(demand.linkedDemands)) {
    return [];
  }
  return demand.linkedDemands.filter(
    (item) => String(item?.id) !== String(demand?.id),
  );
};

const DemandsInActiveTable = ({
  // handleViewDetail,
  searchString,
  filterValue,
  handleResetFilter,
  showAdvancedSearchBar,
  selectedProductName,
}) => {
  const dispatch = useDispatch();
  const [deleteRowId, setDeleteRowId] = useState('');
  const [reactivateRow, setReactivateRow] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const [showBulkReactivate, setShowBulkReactivate] = useState(false);
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  // const [updateRecordModal, setUpdateRecordModal] = useState(false);
  // const [selectedUserRow, setSelectedUserRow] = useState([]);
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'entityName',
        joinAttributeName: 'trader',
        value: searchString,
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'status',
        value: 'EXPIRED,REACTIVATED,INACTIVE',
        type: 'STRING',
        op: 'IN',
      },
      {
        key: 'demandType',
        value: 'All',
        type: 'STRING',
        op: 'EQ',
      },
      {
        ...defaultDeleteFilter,
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });
  // Build the product name filter for GraphQL
  const productNameFilter = useMemo(() => {
    if (!selectedProductName) return [];
    return [
      {
        key: 'name',
        value: selectedProductName,
        joinAttributeName: 'grades.subCategory.product',
        type: 'STRING',
        op: 'EQ',
      },
    ];
  }, [selectedProductName]);

  // Combine all filters for the GraphQL query
  const graphqlVariables = useMemo(() => ({
    filter: [
      ...filters.filter,
      ...filterValue,
      ...productNameFilter,
    ],
    pageNo: filters.pageNo,
    pageSize: filters.pageSize,
    sortCol: filters.sortCol,
    sortDirection: filters.sortDirection,
  }), [filters, filterValue, productNameFilter]);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    DEMANDS_QUERY,
    {
      variables: graphqlVariables,
      fetchPolicy: 'network-only',
    },
  );

  const [deleteDemand] = useMutation(DELETE_DEMAND, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        return message;
      });
    },
  });
  const [updateDemandStatus] = useMutation(ADMIN_UPDATE_DEMAND_STATUS);

  // const [updateDemandStatus] = useMutation(UPDATE_DEMAND_STATUS, {
  //   // eslint-disable-next-line no-shadow
  //   onCompleted: () => {
  //     toast.success(STATUS_UPDATED_SUCCESSFULLY);
  //   },
  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.map(({ exception }) => {
  //       toast.error(exception?.message);
  //       return exception;
  //     });
  //   },
  // });
  // const onClickEdit = ({ row }) => {
  //   setUpdateRecordModal(true);
  //   setSelectedUserRow(row?.original);
  // };

  // const onCloseUpdatePopup = () => {
  //   setUpdateRecordModal(false);
  // };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteDemand({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };
  // const actionsFormatter = (cell) => {
  //   return (
  //     <ActionsFormatter
  //       isView={false}
  //       handleView={() => handleViewDetail(cell?.row?.original, 'demandType')}
  //       handleEdit={() => onClickEdit(cell)}
  //       handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
  //     />
  //   );
  // };

  // const handleOfferStatus = async (e, cell) => {
  //   try {
  //     await updateDemandStatus({
  //       variables: { id: cell?.row?.original?.id, status: e.target.value },
  //     });
  //     refetch();
  //   } catch (err) {
  //     toast.error(err);
  //   }
  // };

  // const statusFormatter = (cell) => {
  //   return (
  //     <StatusFormatter
  //       options={MARKET_LIST_STATUS}
  //       defaultValue={cell?.row?.original?.status}
  //       handleChange={(e) => handleOfferStatus(e, cell)}
  //     />
  //   );
  // };

  const handleLinkClick = (row) => {
    dispatch(
      setBidDetails({
        status: true,
        selectedBid: {
          ...row,
          bidType: 'demand',
          bidDemandType: 'LIVE',
          filters,
        },
      }),
    );
  };
  const linkFormatter = (cell) => {
    const parentDemand = cell?.row?.original;
    const isExpanded = cell?.row?.getIsExpanded?.();
    const linkedDemands = getValidLinkedDemands(parentDemand);

    return (
      <div className="d-flex flex-column">
        <div
          className="text-blue-c5 fw-medium cursor-pointer d-flex align-items-center"
          style={{ minHeight: '44px' }}
          onClick={() => handleLinkClick(parentDemand)}
          aria-hidden
        >
          <span className="me-2 f-16">{parentDemand?.id}</span>{' '}
          <FaArrowUpRightFromSquare />
        </div>
        {isExpanded &&
          linkedDemands.map((linkedItem) => {
            const mergedItem = {
              ...parentDemand,
              ...linkedItem,
              id: linkedItem.id,
              totalQty: linkedItem.totalQty,
              rate: linkedItem.rate ?? parentDemand.rate,
              grades: linkedItem?.grades?.length ? linkedItem.grades : parentDemand.grades,
            };
            return (
              <div
                key={linkedItem.id}
                className="text-blue-c5 fw-medium cursor-pointer d-flex align-items-center"
                style={{
                  minHeight: '44px',
                  borderTop: '1px dashed #e2e8f0',
                }}
                onClick={() => handleLinkClick(mergedItem)}
                aria-hidden
              >
                <span className="me-2 f-16">{linkedItem.id}</span>{' '}
                <FaArrowUpRightFromSquare />
              </div>
            );
          })}
      </div>
    );
  };

  const gradeFormatter = (cell) => {
    const parentDemand = cell?.row?.original;
    const isExpanded = cell?.row?.getIsExpanded?.();
    const linkedDemands = getValidLinkedDemands(parentDemand);

    return (
      <div className="d-flex flex-column">
        <div
          className="d-flex flex-column align-items-start justify-content-center"
          style={{ minHeight: '44px' }}
        >
          {parentDemand?.grades?.map((grade) => (
            <GradeBadge key={grade?.id} grade={grade} />
          ))}
        </div>
        {isExpanded &&
          linkedDemands.map((linkedItem) => (
            <div
              key={linkedItem.id}
              className="d-flex flex-column align-items-start justify-content-center"
              style={{
                minHeight: '44px',
                borderTop: '1px dashed #e2e8f0',
              }}
            >
              {(linkedItem?.grades?.length ? linkedItem.grades : parentDemand?.grades)?.map((grade) => (
                <GradeBadge key={grade?.id} grade={grade} />
              ))}
            </div>
          ))}
      </div>
    );
  };

  const totalQtyFormatter = (cell) => {
    const parentDemand = cell?.row?.original;
    const isExpanded = cell?.row?.getIsExpanded?.();
    const linkedDemands = getValidLinkedDemands(parentDemand);

    return (
      <div className="d-flex flex-column">
        <div
          className="d-flex align-items-center"
          style={{ minHeight: '44px' }}
        >
          {NumberWithCommasFormat(parentDemand?.totalQty)}{' '}
          {parentDemand?.actualQuantityUnit || parentDemand?.quantityUnit}
        </div>
        {isExpanded &&
          linkedDemands.map((linkedItem) => (
            <div
              key={linkedItem.id}
              className="d-flex align-items-center"
              style={{
                minHeight: '44px',
                borderTop: '1px dashed #e2e8f0',
              }}
            >
              {NumberWithCommasFormat(linkedItem?.totalQty)}{' '}
              {parentDemand?.actualQuantityUnit || parentDemand?.quantityUnit}
            </div>
          ))}
      </div>
    );
  };

  const rateFormatter = (cell) => {
    const parentDemand = cell?.row?.original;
    const isExpanded = cell?.row?.getIsExpanded?.();
    const linkedDemands = getValidLinkedDemands(parentDemand);

    return (
      <div className="d-flex flex-column">
        <div
          className="text-nowrap d-flex align-items-center"
          style={{ minHeight: '44px' }}
        >
          {`${currencyToLocal(
            parentDemand?.rate,
            parentDemand?.rateUnit?.isoCurrencyCode,
          )}/${parentDemand?.quantityUnit}`}
        </div>
        {isExpanded &&
          linkedDemands.map((linkedItem) => (
            <div
              key={linkedItem.id}
              className="text-nowrap d-flex align-items-center"
              style={{
                minHeight: '44px',
                borderTop: '1px dashed #e2e8f0',
              }}
            >
              {`${currencyToLocal(
                linkedItem?.rate ?? parentDemand?.rate,
                parentDemand?.rateUnit?.isoCurrencyCode,
              )}/${parentDemand?.quantityUnit}`}
            </div>
          ))}
      </div>
    );
  };

  const handleNameClick = (row) => {
    if (!row?.trader?.id) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row.trader,
      }),
    );
  };
  // const nameFormatter = (cell) => {
  //   return (
  //     <div
  //       className="text-blue-c5 fw-medium cursor-pointer"
  //       onClick={() => handleNameClick(cell?.row?.original?.trader)}
  //       aria-hidden
  //     >
  //       {cell?.row?.original?.trader?.firstName}{' '}
  //       {cell?.row?.original?.trader?.lastName}
  //     </div>
  //   );
  // };



  const openReactivateModal = (row) => {
    setReactivateRow(row);
  };

  const closeReactivateModal = () => {
    setReactivateRow(null);
  };

  const selectedIds = Object.keys(rowSelection);

  const resetRowSelection = () => {
    setRowSelection({});
  };

  const toggleBulkReactivate = () => {
    setShowBulkReactivate((prev) => !prev);
  };

  const handleBulkReactivate = async () => {
    if (!selectedIds.length) return;

    try {
      setBulkSubmitting(true);
      await Promise.all(
        selectedIds.map((id) =>
          updateDemandStatus({
            variables: { id, status: 'ACTIVE' },
          }),
        ),
      );
      toast.success(`${selectedIds.length} demands activated successfully`);
      setShowBulkReactivate(false);
      resetRowSelection();
      refetch();
    } catch (err) {
      toast.error(err?.message || 'Failed to activate selected demands');
    } finally {
      setBulkSubmitting(false);
    }
  };

  const renderReactivateButton = (row) => {
    return (
      <button
        type="button"
        className="btn btn-outline-primary btn-sm d-inline-flex align-items-center justify-content-center"
        onClick={() => openReactivateModal(row)}
        title="Reactivate demand"
        aria-label="Reactivate demand"
      >
        <FiRefreshCw />
      </button>
    );
  };

  const reactivateFormatter = (cell) =>
    renderReactivateButton(cell?.row?.original);

  const localDemandsInActiveColumns = [...demandsInActiveColumns];

  const renderRoleColumn = ({ row }) => {
    // eslint-disable-next-line no-underscore-dangle
    const role = row?.original?.trader?.__typename;
    return (
      <div className="px-1 text-capitalize">
        {role?.toLowerCase() || '-'}
      </div>
    );
  };

  if (!localDemandsInActiveColumns.find(c => c.accessorKey === 'role')) {
    localDemandsInActiveColumns.push({
      accessorKey: 'role',
      header: 'Role',
      enableSorting: false,
      cell: renderRoleColumn,
    });
  }

  const findIndexOfItemLocal = (item) => {
    return localDemandsInActiveColumns.findIndex((itm) => itm.accessorKey === item);
  };

  // demandsInActiveColumns[findIndexOfItem('status')].cell = statusFormatter;
  // demandsInActiveColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  localDemandsInActiveColumns[findIndexOfItemLocal('id')].cell = linkFormatter;

  const gradesIdx = findIndexOfItemLocal('grades');
  if (gradesIdx !== -1) {
    localDemandsInActiveColumns[gradesIdx].cell = gradeFormatter;
    localDemandsInActiveColumns[gradesIdx].accessorFn = undefined;
  }

  const totalQtyIdx = findIndexOfItemLocal('totalQty');
  if (totalQtyIdx !== -1) {
    localDemandsInActiveColumns[totalQtyIdx].cell = totalQtyFormatter;
  }

  const rateIdx = localDemandsInActiveColumns.findIndex(
    (itm) => itm.accessorKey === 'rate' || itm.id === 'rate',
  );
  if (rateIdx !== -1) {
    localDemandsInActiveColumns[rateIdx].cell = rateFormatter;
  }

  localDemandsInActiveColumns[findIndexOfItemLocal('SNo')].cell = ({ cell, row }) => {
    return (
      <div
        className="d-flex align-items-center"
        style={{ minHeight: '44px' }}
      >
        <span className="me-1">{showSequenceNumber(cell, filters)}</span>
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer', lineHeight: 1 },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess size={20} />
            ) : (
              <MdOutlineExpandMore size={20} />
            )}
          </Button>
        ) : null}
      </div>
    );
  };
  localDemandsInActiveColumns[findIndexOfItemLocal('reactivate')].cell =
    reactivateFormatter;
  // demandsInActiveColumns[findIndexOfItem('trader')].cell = nameFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.demands?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
        id: filters.sortCol,
        desc: filters.sortDirection === 'DESC',
      },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: DEMANDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.demands.demands.findIndex(
          (val) => val.id === subscriptionData.data.demands.demand.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.demands?.demand) return prev;
        if (subscriptionData.data.demands.action === 'CREATED') {
          const newDemand = subscriptionData.data.demands.demand;
          const updatedDemands = [newDemand, ...newData.demands.demands];

          const newTotalCount = prev.demands.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.demands = {
            ...newData.demands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            demands: updatedDemands,
          };
        }
        if (subscriptionData.data.demands.action === 'UPDATED') {
          newData.demands.demands[indexFound] =
            subscriptionData.data.demands.demand;
        }

        if (subscriptionData.data.demands.action === 'DELETED') {
          const { id } = subscriptionData.data.demands.demand; // ID of the demand to remove
          const prevDemands = prev.demands.demands;

          const updatedDemands = prevDemands.filter((val) => val.id !== id);

          const newTotalCount = prev.demands.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedDemandsData = {
            ...newData.demands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            demands: updatedDemands,
          };

          newData.demands = updatedDemandsData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.demands?.demands)
    return <NoDataFound message="Demands not available" />;

  return (
    <>
      {showAdvancedSearchBar && data?.demands?.demands?.length > 0 && (
        <FilterResultBar
          length={data?.demands?.demands?.length}
          type="demands"
          handleResetFilter={handleResetFilter}
        />
      )}
      {/* <FSBModal
        title="Edit Demands"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={updateRecordModal}
        onClose={onCloseUpdatePopup}
        toggleAlert={onCloseUpdatePopup}
        modalClass="right-drawer"
      >
        {selectedUserRow?.demandType === types.LIVE && (
          <EditLiveWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}
        {selectedUserRow?.demandType === types.FORWARD && (
          <EditForwardWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}
        {selectedUserRow?.demandType === types.FOREIGN && (
          <EditForeignWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}{' '}
      </FSBModal> */}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <DeleteConfirmationAlert
        open={showBulkReactivate}
        title="Reactivate"
        message={`Do you want to active selected ${selectedIds.length} demands?`}
        cancelButtonLabel="Close"
        addButtonLabel="Active"
        confirmButtonColor="primary"
        loading={bulkSubmitting}
        onConfirm={handleBulkReactivate}
        onCancel={toggleBulkReactivate}
        toggleAlert={toggleBulkReactivate}
      />
      <ReactivateListingModal
        isOpen={!!reactivateRow}
        kind="demand"
        row={reactivateRow}
        onClose={closeReactivateModal}
        onSuccess={refetch}
      />
      <DownloadCSV
        lazyQuery={EXPORTS_DEMANDS}
        filters={{
          filter: graphqlVariables.filter,
          sortCol: filters.sortCol,
          sortDirection: filters.sortDirection,
        }}
        apiKey="exportDemands"
        fileName="InactiveDemands"
        formats={["csv", "excel"]}
        classWrapper="market-listing-download"
        positionTop="-34px"
        positionRight="0"
      />
      {selectedIds.length ? (
        <div className="muiltiple-action-box d-inline-flex align-items-center ps-3 mt-2 mb-1">
          <span className="text-dark me-3">
            Viewing{' '}
            <span className="fw-semibold">{selectedIds.length} selected</span>{' '}
            from list of demands
          </span>
          <button
            type="button"
            className="btn btn-link p-0 d-inline-flex align-items-center"
            onClick={toggleBulkReactivate}
          >
            <FiRefreshCw className="me-1" /> Reactivate
          </button>
        </div>
      ) : null}
      <MarketListingMobileView
        rows={(data && data?.demands?.demands) || []}
        filters={filters}
        kind="demand"
        totalPages={(data && data?.demands?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        currentPageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        onIdClick={handleLinkClick}
        onNameClick={handleNameClick}
        renderStatusControl={() => <span className="text-muted">Inactive</span>}
        renderRowAction={renderReactivateButton}
      >
        <FSBTable
          getRowId={(row) => row.id}
          data={(data && data?.demands?.demands) || []}
          totalCount={(data && data?.demands?.totalCount) || 0}
          totalPages={(data && data?.demands?.totalPages) || 0}
          columns={localDemandsInActiveColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
          onSelectedRowsChange={setRowSelection}
          rowSelection={rowSelection}
          getRowCanExpand={(row) =>
            getValidLinkedDemands(row?.original).length > 0
          }
          isRowExpanded={false}
        />
      </MarketListingMobileView>
    </>
  );
};
export default DemandsInActiveTable;
